// SAD-999: what the Command Center says, computed from the summary as the
// server gave it. Value, target and tone are the server's one computation
// (SAD-998); this module only words them and says where each one drills.
import { listHrefFor } from './listView';
/** The tone a reading paints: green on target, red off it, grey with no data. */ export function toneOf(k) {
    if (k?.tone === 'green') return 'success';
    if (k?.tone === 'red') return 'danger';
    return 'neutral';
}
/** A reading's value as printed: a percent for on-time, a count otherwise. */ export function valueText(k) {
    if (!k?.hasValue) return 'No data yet';
    return k.id === 'on_time' ? `${k.value}%` : k.value.toLocaleString();
}
/** The deliverable state each tile drills into. */ export const DRILL_STATE = {
    on_time: 'approved',
    late_now: 'late',
    due_next_14_days: 'due_soon',
    waiting_on_approval: 'awaiting_review'
};
/**
 * Where a tile's rows are. With one program in view, that program's
 * deliverables list, filtered to the state (the existing list page); with
 * several, the portfolio deliverables list narrowed to that state (SAD-1000).
 */ export function drillHref(state, filter, programIds) {
    const only = filter.programs.length === 1 ? filter.programs[0] : programIds.length === 1 ? programIds[0] : '';
    if (only) return `/delivery/programs/${only}/deliverables?state=${encodeURIComponent(state)}`;
    return listHrefFor({
        ...filter,
        states: [
            state
        ]
    });
}
/**
 * Where a chart mark's or a tile's rows are: the portfolio deliverables list
 * under this filter (SAD-1000).
 */ export function listHref(filter) {
    return listHrefFor(filter);
}
const plural = (n, one, many = `${one}s`)=>`${n.toLocaleString()} ${n === 1 ? one : many}`;
/**
 * The page's one-line factual summary: how many programs, how many dates are
 * late and where most of them are, how many filings wait on approval.
 */ export function headline(s) {
    if (!s) return '';
    const programs = s.programs.length;
    if (programs === 0) return 'No programs in view.';
    const late = s.totals?.stateCounts.late ?? 0;
    const waiting = s.totals?.waitingOnApproval ?? 0;
    const parts = [
        plural(programs, 'program')
    ];
    if (late > 0) {
        let lateText = `${plural(late, 'deliverable')} late`;
        const top = [
            ...s.programs
        ].sort((a, b)=>(b.counts?.stateCounts.late ?? 0) - (a.counts?.stateCounts.late ?? 0))[0];
        const topLate = top?.counts?.stateCounts.late ?? 0;
        if (programs > 1 && top && topLate > 0) {
            lateText += topLate === late ? `, all on ${top.name}` : `, ${topLate} of them on ${top.name}`;
        }
        parts.push(lateText);
    } else {
        parts.push('nothing late');
    }
    parts.push(`${waiting.toLocaleString()} waiting on approval`);
    return `${parts.join(' · ')}.`;
}
